// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import BottomSlider from '../components/BottomSlider';
import HomeSection from '../components/HomeSection';
import { useWebContent } from '../hooks/useWebContent';
import { useUpdateHeadTags } from '../hooks/useUpdateHeadTags';
import { useAdverts } from '../hooks/useAdverts';
import AdvertPopup from '../components/AdvertPopup';

function Home() {
  const location = useLocation();
  const { data: webContent, isLoading, isError, error } = useWebContent();
  const { headers, headersLoading } = useUpdateHeadTags('home');

  // Advert popup logic
  const { data: advertsData } = useAdverts({ position_key: 'home_popup', ad_format: 'popup', useWebContent: true });
  const [showAdvert, setShowAdvert] = useState(false);
  const [shownOnce, setShownOnce] = useState(false);

  useEffect(() => {
    if (!isLoading && advertsData?.dataset?.data?.length && !shownOnce) {
      setShowAdvert(true);
      setShownOnce(true);
    }
  }, [isLoading, advertsData, shownOnce]);

  useEffect(() => {
    const scrollToSection = (hash) => {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const section = document.getElementById(hash.replace('#', ''));
      if (section) {
        const offsetTop = section.offsetTop - headerHeight;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    };

    if (location.hash === '#features' || location.hash === '#testimonials') {
      scrollToSection(location.hash);
    }
  }, [location]);

  const handleCloseAdvert = () => setShowAdvert(false);

  function getRandomAdvert(advertData) {
    const arr = advertData?.dataset?.data;
    if (Array.isArray(arr) && arr.length > 0) {
      const idx = Math.floor(Math.random() * arr.length);
      return arr[idx];
    }
    return undefined;
  }
  const popupAdvert = getRandomAdvert(advertsData);

  return (
    <>
      <HeroSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <BottomSlider webContent={webContent} isLoading={isLoading} />
      <HomeSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />

      <AdvertPopup
        advert={popupAdvert}
        show={showAdvert}
        onClose={handleCloseAdvert}
        position_key="home_popup"
        useWebContent={true}
      />
    </>
  );
}

export default Home;

